import 'twin.macro';
import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import Button from '@teetsh/app/src/components/Buttons/Button';

interface OnboardingModulePageWrapperProps {
  title: string;
  onBack: () => void;
  children: React.ReactNode;
}

export function OnboardingModulePageWrapper({
  title,
  onBack,
  children,
}: OnboardingModulePageWrapperProps) {
  return (
    <div tw="m-4">
      <div tw="mb-6 py-4 w-full inline-flex items-center justify-between">
        <Button
          onClick={onBack}
          minimal
          intent="none"
          icon={ArrowLeftIcon}
          aria-label="Retour"
        />
        <h1 tw="pr-9 grow text-center">{title}</h1>
      </div>
      {children}
    </div>
  );
}
